module.exports = function(text) {
  return text.toLowerCase();
}
